import makeService from '~/services/api';

export default makeService('/deployment_credentials');
